import { Injectable } from '@angular/core';
import { APIS } from 'src/app/apis';
import { TeamStateAggData } from './data-data';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private teamStateAggDataUrl = `${APIS.data}/getTeamStateAggData`;

  constructor(private http: HttpClient) { }

  getTeamStateAggData(userIdOverride: string, orgIdOverride: string) : Observable <TeamStateAggData> {
   
    
    return this.http.get<TeamStateAggData>(`${this.teamStateAggDataUrl}?userIdOverride=${userIdOverride}&orgIdOverride=${orgIdOverride}`); 
  }

}
